import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class generalSettingStore {

    // PROPERTIES

    @observable currencies = [];
    @observable timezones = [];
    @observable stayMenuCategories = [];
    @observable parentItems = [];
    @observable configuration = null;
    @observable configurationModel = null;
    @observable generalSettingLoading = false;
    @observable currencyCode = '';
    @observable timezoneCode = '';

    // INITIALIZATION

    @action initGeneralSetting() {
        this.generalSettingLoading = true;

        return ApiCaller.Configuration.apiGetConfigurations().then((configurationResponse) => {
            if (configurationResponse) {
                this.configuration = configurationResponse;

                ApiCaller.Item.apiGetParents().then((parentsResponse) => {
                    if (parentsResponse) {
                        this.parentItems = parentsResponse;

                        ApiCaller.Currency.apiGetCurrencies().then((currencyResponses) => {
                            if (currencyResponses) {
                                this.currencies = currencyResponses;

                                ApiCaller.Timezone.apiGetTimezones().then((timezoneResponses) => {
                                    if (timezoneResponses) {
                                        this.timezones = timezoneResponses;
        
                                        ApiCaller.Item.apiGetStayMenuCategories().then((stayMenuCategoryResponses) => {
                                            this.stayMenuCategories = stayMenuCategoryResponses;
        
                                            this.generalSettingLoading = false;
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
            } else {
                this.configuration = null;
                this.generalSettingLoading = false;
            }
        })
    }

    @action initGeneralSettingModel() {
        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.Configuration.apiGetConfigurationModelByLanguageCode(languageCode).then((configurationModelResponse) => {
            if (configurationModelResponse) {
                this.configurationModel = configurationModelResponse;
            } else {
                this.configurationModel = null;
            }
        });
    }

    @action initCurrency() {
        return ApiCaller.Currency.apiGetCurrencyFromSetting().then((currencyResponse) => {
            if (currencyResponse) {
                this.currencyCode = currencyResponse.currencyCode;
            } else {
                this.currencyCode = '';
            }
        });
    }

    @action initTimezone() {
        return ApiCaller.Timezone.apiGetTimezoneFromSetting().then((timezoneResponse) => {
            if (timezoneResponse) {
                this.timezoneCode = timezoneResponse.timezoneCode;
            } else {
                this.timezoneCode = '';
            }
        });
    }

    // CLICKED Properties

    @action saveGeneralSettingClicked() {
        this.generalSettingLoading = true;
        if (this.configuration.generalSettingId === 0) {
            return ApiCaller.Configuration.apiCreateConfigurations(this.configuration).then((createResponse) => {
                this.configuration = createResponse;
                this.generalSettingLoading = false;
            });
        } else {
            return ApiCaller.Configuration.apiUpdateConfigurations(this.configuration.generalSettingId, this.configuration).then((updateResponse) => {
                this.configuration = updateResponse;
                this.generalSettingLoading = false;
            });
        }
    }

    // ON CHANGE

    @action companyIdOnChange(value) {
        if (value !== '') {
            this.configuration.companyId = parseInt(value);
        } else {
            this.configuration.companyId = 0;
        }
    }

    @action stayMenuOnChange(value) {
        if (value !== '') {
            this.configuration.stayMenuTaskId = parseInt(value);
        } else {
            this.configuration.stayMenuTaskId = 0;
        }
    }

    @action currencyOnChange(value) {
        this.configuration.currency = value;
    }

    @action vatOnChange(value) {
        if (value !== '') {
            this.configuration.vat = parseInt(value);
        } else {
            this.configuration.vat = 0;
        }
    }

    @action serviceFeeOnChange(value) {
        if (value !== '') {
            this.configuration.serviceFee = parseInt(value);
        } else {
            this.configuration.serviceFee = 0;
        }
    }

    @action countryWeatherOnChange(value) {
        this.configuration.countryWeather = value;
    }

    @action timezoneOnChange(value) {
        this.configuration.timezone = value;
    }

    @action amenityTaskIdOnChange(value) {
        this.configuration.amenitiesTaskId = parseInt(value);
    }

    @action bookTaxiTaskIdOnChange(value) {
        this.configuration.bookTaxiTaskId = parseInt(value);
    }

    @action cleanRoomTaskIdOnChange(value) {
        this.configuration.cleanRoomTaskId = parseInt(value);
    }

    @action conciergeItemChanged(value) {
        this.configuration.conciergeTaskId = parseInt(value);
    }

    @action defectReportTaskIdOnChange(value) {
        this.configuration.defectReportTaskId = parseInt(value);
    }

    @action dndTaskIdOnChange(value) {
        this.configuration.dndTaskId = parseInt(value);
    }

    @action fnbTaskIdOnChange(value) {
        this.configuration.fnbTaskId = parseInt(value);
    }

    @action frontOfficeTaskIdOnChange(value) {
        this.configuration.frontOfficeTaskId = parseInt(value);
    }

    @action lateCheckoutTaskIdOnChange(value) {
        this.configuration.lateCheckoutTaskId = parseInt(value);
    }

    @action laundryTaskIdOnChange(value) {
        this.configuration.laundryTaskId = parseInt(value);
    }

    @action printFileTaskIdOnChange(value) {
        this.configuration.printFileTaskId = parseInt(value);
    }

    @action shoppingTaskIdOnChange(value) {
        this.configuration.shoppingTaskId = parseInt(value);
    }

    @action wakeUpCallTaskIdOnChange(value) {
        this.configuration.wakeUpCallTaskId = parseInt(value);
    }

    // SET Properties

    @action setCleanRoomIsSelected(taskId, isSelected) {
        const data = this.configurationModel.cleanRoomItems.find(x => x.taskId === taskId);
        data.isSelected = isSelected;
    }

    @action setConciergeIsSelected(taskId, isSelected) {
        const data = this.configurationModel.conciergeItems.find(x => x.taskId === taskId);
        data.isSelected = isSelected;
    }

    @action setDndIsSelected(taskId, isSelected) {
        const data = this.configurationModel.dndItems.find(x => x.taskId === taskId);
        data.isSelected = isSelected;
    }

    @action setLateCheckoutIsSelected(taskId, isSelected) {
        this.configurationModel.lateCheckoutItems.map(item => {
            return item.isSelected = false;
        });

        if (isSelected) {
            const data = this.configurationModel.lateCheckoutItems.find(x => x.taskId === taskId);
            data.isSelected = isSelected;
        }
    }

    // RESET Properties

    @action resetGeneralSetting() {
        this.currencies = [];
        this.timezones = [];
        this.stayMenuCategories = [];
        this.parentItems = [];
        this.configuration = null;
        this.configurationModel = null;
        this.currencyCode = '';
        this.timezoneCode = '';
    }
}

export default new generalSettingStore()